import { getCurrencyScale, getFormattedPrice } from '@business/utils/currency';
/** A Money object's minor-unit amount converted to major units, e.g.
 * `{ amount: "15000", currencyCode: "USD" }` -> 150. `null` means no rate —
 * absent, or a non-numeric amount, which must not silently become a
 * misleading free ($0.00) rate. */
const toAmount = (money) => {
    if (!(money === null || money === void 0 ? void 0 : money.amount)) {
        return null;
    }
    const amount = Number(money.amount);
    if (!Number.isFinite(amount)) {
        return null;
    }
    const currency = (money.currencyCode || 'usd').toLowerCase();
    return getFormattedPrice(amount, getCurrencyScale(currency));
};
const toProperty = (raw) => {
    var _a, _b, _c;
    return ({
        // The row itself carries no currencyCode — it's the search currency, read
        // off whichever Money object is present. Neither is present when the
        // property has no vacancy, so this can legitimately be ''.
        currencyCode: ((_a = raw.minNightlyRate) === null || _a === void 0 ? void 0 : _a.currencyCode) || ((_b = raw.minTotalPrice) === null || _b === void 0 ? void 0 : _b.currencyCode) || '',
        // The contract calls this hasAvailability; the rest of the FE keeps the
        // established hasVacancy name for the same concept.
        hasVacancy: (_c = raw.hasAvailability) !== null && _c !== void 0 ? _c : false,
        id: Number(raw.id) || 0,
        minNightlyRate: toAmount(raw.minNightlyRate),
        minTotalPrice: toAmount(raw.minTotalPrice),
    });
};
export default class OrganizationAvailability {
    constructor(serverData) {
        var _a, _b, _c;
        Object.defineProperty(this, "checkIn", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "checkOut", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "properties", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        if (!(serverData === null || serverData === void 0 ? void 0 : serverData.success) || !serverData.data) {
            return;
        }
        const { data } = serverData;
        this.checkIn = (_a = data.checkIn) !== null && _a !== void 0 ? _a : '';
        this.checkOut = (_b = data.checkOut) !== null && _b !== void 0 ? _b : '';
        this.properties = ((_c = data.properties) !== null && _c !== void 0 ? _c : []).map(toProperty);
    }
}
